import React, { useMemo } from 'react';
import textAdditionalClassName from '../../../helpers/utils/TextAdditionalClassName';

interface Head6Props {
  children: React.ReactNode;
  className?: string;
  maxLines?: number;
  isClamp?: boolean;
  style?: React.CSSProperties;
  textBreak?: 'words' | 'characters' | 'none';
  overflow?: 'hidden' | 'visible';
  as?: keyof JSX.IntrinsicElements;
}

const Head6 = ({
  children,
  maxLines = 2,
  className = '',
  isClamp = false,
  style = {},
  textBreak = 'words',
  overflow = 'hidden',
  as: Tag = 'h6',
  ...props
}: Head6Props & React.ComponentProps<'h6'>) => {
  const lineClampStyle: React.CSSProperties = isClamp
    ? {
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        display: '-webkit-box',
      }
    : {};

  const additionalClassName = useMemo(
    () => textAdditionalClassName(textBreak, overflow),
    [textBreak, overflow]
  );

  return Tag === 'h6' ? (
    <h6
      style={{ ...lineClampStyle, ...style }}
      className={`text-[16px] font-bold leading-6 text-black90 ${additionalClassName} ${className}`}
      {...props}
    >
      {children}
    </h6>
  ) : (
    <Tag
      style={{ ...lineClampStyle, ...style }}
      className={`text-[16px] font-bold leading-6 text-black90 ${additionalClassName} ${className}`}
    >
      {children}
    </Tag>
  );
};

export default Head6;
